/**
 * @file 投稿ボタン
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname BtnPost
 * @classdesc 投稿ボタン
 */
export default class BtnPost {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 * @param {object} controller - controller オブジェクト
	 */
	constructor($e, controller) {
		console.log('BtnPost.constructor');
		this._$e = $e;
		this._controller = controller;
		this._$form = $('#form-create-information');
		this._$modal = $('#modal-submit');
		this._$submitModal = new bootstrap.Modal(document.getElementById('modal-submit'))
		$e.on('click', () => this.onClick());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof BtnPost
	 * @return {undefined}
	 */
	onClick() {
		console.log('BtnPost.onClick');
		this._$modal.find('.text').hide();
		this._controller.createHtml(true);
		this._controller.validate();
		setTimeout(() => {
			this.showModal();
		}, 500);
		//$('#modal-submit')[0].show();
	};

	showModal() {
		console.log('BtnPost.showModal');
		let errorFlg = false;
		$('.validate').each((idx, e) => {
			const $e = $(e);
			if ($e.hasClass('is-invalid')) {
				console.log(`ERROR!(BtnPost): ${$e.attr('name')}`);
				errorFlg = true;
			}
		});
		if (errorFlg) {
			Common.showErrorModal();
			return;
		}
		this._controller.deleteSubmit();
		this._controller.createHtml(true);
		const now = new Date();
		const postDate = $('[name="published_start_at"]').val();
		console.log(postDate);
		if (postDate && postDate !== '') {
			const tmp = postDate.split('-');
			const post = new Date(tmp[0], tmp[1] - 1, tmp[2], 0, 0, 0);
			if (post > now) {
				$('.text-feature-post').show();
			} else {
				$('.text-immediate-post').show();
			}
			//this._$modal.addClass('show');
			this._$submitModal.show();
		}
	}
}
